import React, { memo, useEffect, useState } from 'react'
import {
  OFFER_TYPE_CRUISE,
} from 'constants/offer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import LayoutContainer from 'components/Common/LayoutContainer'

import Heading from 'components/Luxkit/Typography/Heading'
import useOfferList from 'hooks/Offers/useOfferList'
import { EmptyObject } from 'lib/object/objectUtils'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import { OfferListEventsProvider } from 'components/OfferList/OfferListEventsContext'
import VerticalSpacer from '../Spacing/VerticalSpacer'
import useOfferListTracking from 'hooks/Offers/useOfferListTracking'

const emptyFilters: App.OfferListFilters = EmptyObject

interface Props {
  filters?: App.OfferListFilters;
  offerId: string;
}

const RECOMMENDATION_TYPES: App.OfferType[] = [
  OFFER_TYPE_CRUISE,
]

function CruiseRecommendations(props: Props) {
  const {
    filters = emptyFilters,
    offerId,
  } = props

  const [wideSearch, setWideSearch] = useState<boolean>(false)
  const offerList = useOfferList({
    ...filters,
    offerTypes: RECOMMENDATION_TYPES,
    offerIdsToExclude: [offerId],
    // searching per cruise line can be a little restrictive at times
    // and we want to show a mininum number of offers
    // so if we didn't get any, widen our search to not restrict on cruise lines
    cruiseLines: wideSearch ? undefined : filters.cruiseLines,
  })

  const tracking = useOfferListTracking('Recommendations - Cruises', {
    ga: {
      category: 'Recommendations',
      label: 'Recommendations - Cruises',
    },
  })

  useEffect(() => {
    if (!offerList.fetching && offerList.offerIds.length < 3) {
      setWideSearch(true)
    }
  }, [offerList])

  if (!offerList.offerIds.length) {
    return null
  }

  return (
    <OfferListEventsProvider tracking={tracking}>
      <Pane>
        <PaneBody size="xl-y">
          <VerticalSpacer gap={16}>
            <LayoutContainer>
              <Heading variant="heading3">You may also like</Heading>
            </LayoutContainer>
            <OfferListCarousel overrideOfferList={offerList} />
          </VerticalSpacer>
        </PaneBody>
      </Pane>
    </OfferListEventsProvider>
  )
}

export default memo(CruiseRecommendations)
